import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DataService } from '../../data.service';
import { MeetingDto } from '../../shared/model';

@Injectable({
  providedIn: 'root'
})
export class RescheduleViewService {

  constructor(private dataService: DataService) { }

  rescheduleMeeting(meetingDto: MeetingDto): Observable<any> {
    return this.dataService.post('Meeting/RescheduleMeeting',  meetingDto);
  }

}
